(ns frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.view
  (:require
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.toc-page :as toc]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.fund-overview :as fund-overview]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.fund-status :as fund-status]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.investor-information
    :as investor-information]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.portfolio-information
    :as portfolio-information]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.esg :as esg]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.team-letter :as team-letter]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.fees-interest-expenses :as fees]))


(defn innovestor-pages
  [data]
  (concat
   (toc/toc-page {:cover-image :front-page-image
                  :report-data data})
   (team-letter/team-letter-pages data)
   [(fund-overview/fund-overview-page data)]
   (esg/esg-pages data)
   (fund-status/fund-status-pages data)
   (investor-information/investor-information-pages data)
   (fees/fees-interest-expenses data)
   (portfolio-information/portfolio-information-page data)))

(defn innovestor-feeder-pages
  [data]
  (concat
   (toc/toc-page {:cover-image :front-page-image
                  :report-data data})
   [(fund-overview/fund-overview-page data)]
   (fund-status/fund-status-pages data)
   (investor-information/investor-information-pages data)))

(defn innovestor-tech-fund-pages
  [data]
  (concat
   (toc/toc-page {:cover-image :front-page-image
                  :report-data data})
   (team-letter/team-letter-pages data)
   [(fund-overview/fund-overview-page data)]
   (fund-status/fund-status-pages data)
   (investor-information/investor-information-pages data)
   (fees/fees-interest-expenses data)
   (portfolio-information/portfolio-information-page data)))
